import { TINT_COLOR } from '@tellonym/enums/lib/User'
import { curry } from 'ramda'

export const colors = {
  white: {
    1: '#ffffff',
  },
  black: {
    1: '#14171A',
    2: '#4E5358',
    3: '#3E4245',
  },
  grey: {
    1: '#EDEFF5',
    2: '#F5F5F7',
    3: '#F9F9FA',
    4: '#EBEBED',
    5: '#CECED2',
    6: '#88898F',
    7: '#AFAFB3',
    8: 'rgba(245, 245, 247, 0.72)',
    9: '#808CA5',
    10: '#C5C7C7',
    11: '#B5B3C3',
  },
  turquoise: {
    1: '#39B8AD',
    2: '#088378',
    3: '#DFFFFC',
    4: 'rgba(223, 255, 252, 0.72)',
    5: 'rgba(8, 131, 120, 0.72)',
    6: 'rgba(223, 255, 252, 0.72)',
    7: '#2BC1BA',
    8: 'rgba(43, 193, 186, 0.75)',
  },
  pink: {
    1: '#FF005A',
    2: '#D21E60',
    3: '#FF62AD',
    4: '#533244',
    5: '#722644',
    6: '#3E2633',
    7: '#FF3C80',
    8: '#F36BC1',
    9: 'rgba(255, 0, 90, 0.7)',
    10: 'rgba(243, 107, 193, 0.75)',
  },
  rose: {
    1: '#FFE4F1',
    2: '#FFF4F9',
    3: '#FFF1F8',
    4: 'rgba(255, 1, 123, 0.2)',
    5: '#FCC8D9',
    6: '#FF85FF',
  },
  navy: {
    1: '#1C293F',
    2: '#24334B',
    3: '#3F4F6A',
    4: '#8B96A8',
    5: 'rgba(92, 120, 163, 0.2)',
    6: '#313D52',
    7: '#474D56',
    8: '#1B2330',
    9: '#2B3749',
    10: '#202733',
    11: 'rgba(36, 51, 75, 0.72)',
    12: '#2F343F',
  },
  blue: {
    1: '#22BBEB',
    2: '#4F7AE8',
    3: '#6C95FF',
    4: '#386CF5',
    5: '#264AA7',
    6: '#59C6FF',
    7: '#007AFF',
    8: '#1A73E8',
    9: '#35A6FF',
    10: 'rgba(53, 166, 255, 0.75)',
    11: '#355BE3',
    12: 'rgba(53, 91, 227, 0.75)',
  },
  red: {
    1: '#EA3E33',
    2: 'rgba(234, 62, 51, 0.5)',
    3: '#B81C4D',
    4: '#FFE5E3',
    5: 'rgba(234, 62, 51, 0.75)',
  },
  orange: {
    1: '#FE6600',
    2: '#FD9B63',
    3: '#FEAC34',
    4: 'rgba(254, 172, 52, 0.75)',
    5: '#F0690E',
    6: 'rgba(240, 105, 14, 0.75)',
  },
  transparent: {
    0: 'transparent',
    1: 'rgba(18, 18, 19, 0.2)',
    2: 'rgba(190, 190, 196, 0.2)',
    3: 'rgba(245, 245, 247, 0.3)',
    4: 'rgba(75, 75, 83, 0.4)',
    5: 'rgba(16, 16, 18, 0.4)',
  },
  socials: {
    // TODO: add gradient colors in a useable way
    snapchat: {
      4: '#FFFC00',
      5: '#FCF07E',
    },
  },
  mustard: {
    1: '#FFFEF4',
    2: '#FBF7DA',
    3: '#D7C633',
    4: '#6C6733',
    5: '#847C38',
    6: '#D5C647',
    7: '#ECEE91',
  },
  fuscha: {
    1: '#FFF7FC',
    2: '#FDE8F4',
    3: '#CB4897',
    4: '#8B5174',
    5: '#5D2A49',
    6: '#D75EA7',
    7: '#362240',
  },
  purple: {
    1: '#FCF4FF',
    2: '#F8E5FF',
    3: '#BD67DF',
    4: '#7D5490',
    5: '#5A356B',
    6: '#C65CF7',
  },
  hibiscus: {
    1: '#FFF4F6',
    2: '#FFE5E8',
    3: '#DF6776',
    4: '#895259',
    5: '#61272E',
    6: '#D0616F',
  },
  carrot: {
    1: '#FFF8F4',
    2: '#FFEFE5',
    3: '#E88045',
    4: '#82563E',
    5: '#633E28',
    6: '#D97455',
  },
  violet: {
    1: '#F5F4FF',
    2: '#E8E5FF',
    3: '#7167DF',
    4: '#56518F',
    5: '#2A2656',
    6: '#9086FF',
    7: '#763CBF',
    8: '#C7CAE4',
    9: '#4F1BE5',
    10: 'rgba(113, 103, 223, 0.75)',
  },
  saphire: {
    1: '#F4F8FF',
    2: '#DAE6FF',
    3: '#4A7FE6',
    4: '#4A5F8B',
    5: '#2E436B',
    6: '#5C91FF',
    7: '#27307C',
  },
  green: {
    1: '#F4FFFB',
    2: '#DCFBEE',
    3: '#32C587',
    4: '#2E5847',
    5: '#2B7253',
    6: '#2EC085',
    7: '#C8FFA4',
    8: '#46CD25',
    9: '#1BB269',
    10: '#82BF35',
    11: 'rgba(130, 191, 53, 0.75)',
    12: 'rgba(27, 178, 105, 0.75)',
    13: '#E1F0CF',
    14: '#304319',
    15: '#26B97B',
    16: '#7CFFC8',
  },
  yellow: {
    1: '#FFDA52',
  },
  modcp: {
    1: '#E6F7FF',
    2: '#1890FF',
    3: '#FAFAFA',
  },
  gradient: {
    branding: { 0: ['#FF005A', '#FE566A'] },
  },
}

export const premiumColors = {
  [TINT_COLOR.DEFAULT]: {
    default: colors.pink[1],
    banner: colors.pink[9],
    transparent: {
      20: 'rgba(255, 0, 90, 0.2)',
      40: 'rgba(255, 0, 90, 0.4)',
    },
  },
  [TINT_COLOR.LIGHT_BLUE]: {
    default: colors.blue[9],
    banner: colors.blue[10],
    transparent: {
      20: 'rgba(53, 166, 255, 0.2)',
      40: 'rgba(53, 166, 255, 0.4)',
    },
  },
  [TINT_COLOR.ORANGE]: {
    default: colors.orange[3],
    banner: colors.orange[4],
    transparent: {
      20: 'rgba(254, 172, 52, 0.2)',
      40: 'rgba(254, 172, 52, 0.4)',
    },
  },
  [TINT_COLOR.RED]: {
    default: colors.red[1],
    banner: colors.red[5],
    transparent: {
      20: 'rgba(234, 62, 51, 0.2)',
      40: 'rgba(234, 62, 51, 0.4)',
    },
  },
  [TINT_COLOR.GREEN]: {
    default: colors.green[10],
    banner: colors.green[11],
    transparent: {
      20: 'rgba(130, 191, 53, 0.2)',
      40: 'rgba(130, 191, 53, 0.4)',
    },
  },
  [TINT_COLOR.PURPLE]: {
    default: colors.violet[3],
    banner: colors.violet[10],
    transparent: {
      20: 'rgba(113, 103, 223, 0.2)',
      40: 'rgba(113, 103, 223, 0.4)',
    },
  },
  [TINT_COLOR.DARK_ORANGE]: {
    default: colors.orange[5],
    banner: colors.orange[6],
    transparent: {
      20: 'rgba(240, 105, 14, 0.2)',
      40: 'rgba(240, 105, 14, 0.4)',
    },
  },
  [TINT_COLOR.DARK_GREEN]: {
    default: colors.green[9],
    banner: colors.green[12],
    transparent: {
      20: 'rgba(27, 178, 105, 0.2)',
      40: 'rgba(27, 178, 105, 0.4)',
    },
  },
  [TINT_COLOR.PINK]: {
    default: colors.pink[8],
    banner: colors.pink[10],
    transparent: {
      20: 'rgba(243, 107, 193, 0.2)',
      40: 'rgba(243, 107, 193, 0.4)',
    },
  },
  [TINT_COLOR.BLUE]: {
    default: colors.blue[11],
    banner: colors.blue[12],
    transparent: {
      20: 'rgba(53, 91, 227, 0.2)',
      40: 'rgba(53, 91, 227, 0.4)',
    },
  },
  [TINT_COLOR.TURQUOISE]: {
    default: colors.turquoise[7],
    banner: colors.turquoise[8],
    transparent: {
      20: 'rgba(43, 193, 186, 0.2)',
      40: 'rgba(43, 193, 186, 0.4)',
    },
  },
}

/**
 * In components always use useThemedColor to cause a rerender on Dark Mode toggle
 */
export const getThemedColor = curry((theme, lightColor, darkColor) => {
  if (theme === 'dark') {
    return darkColor
  }

  return lightColor
})
